export const GET_ADDRESSES_WITH_PREFIX_SUCCESS = 'GET_ADDRESSES_WITH_PREFIX_SUCCESS';
export const GET_ADDRESSES_WITH_PREFIX_FAILED = 'GET_ADDRESSES_WITH_PREFIX_FAILED';
export const GET_CONTACTS_WITH_PREFIX_SUCCESS = 'GET_CONTACTS_WITH_PREFIX_SUCCESS';
export const GET_CONTACTS_WITH_PREFIX_FAILED = 'GET_CONTACTS_WITH_PREFIX_FAILED';



// WEBPACK FOOTER //
// src/state/constants/elasticsearchConstants.js